import React, { FC } from 'react';
import classNames from 'classnames';
import ValidationMessage from '../ValidationMessage';
import { SelectFieldProps } from '../models';
import './SelectField.scss';

const SelectField: FC<SelectFieldProps> = ({
  options,
  ariaLabel,
  id,
  label,
  isRequired,
  errorMessage,
  ts,
  ...other
}) => (
  <>
    <div
      className={classNames('form-field select-field', {
        'select-field__error': errorMessage,
      })}
    >
      <label
        htmlFor={id}
        className={classNames('form-field__label', { 'form-field__label--error': isRequired })}
      >
        {ts[label]}
      </label>
      <div className="select-field__wrapper">
        <select
          id={id}
          aria-label={ts[ariaLabel]}
          aria-invalid={!!errorMessage}
          aria-describedby={`${id}Error`}
          {...other}
        >
          <option className="select-field__default" hidden value="default">
            {ts.selectDefaultMessage}
          </option>
          {options?.length &&
            options.map((option) => (
              <option key={option.name} value={option.value}>
                {ts[option.name]}
              </option>
            ))}
        </select>
      </div>
    </div>
    {errorMessage && <ValidationMessage errorId={`${id}Error`} errorMessage={ts[errorMessage]} />}
  </>
);

export default SelectField;
